import { formatUIDate } from 'utils/helpers'

//TODO add type definitions for the items
export const toTableRowItems = (items: any[]): any[] =>
  items.map(item => ({
    id: item.id,
    globalId: item.globalId ?? '',
    adAccount: item.adAccount ?? '',
    ldapAccount: item.ldapAccount ?? '',
    googleAccount: item.googleAccount ?? '',
    startDate: formatUIDate(item.startDate),
    endDate: formatUIDate(item.endDate),
    jobTitle: item.jobTitle ?? '',
    person: item.person ?? '',
    manager: item.manager ?? '',
    externalPartnerType: item.externalPartnerType,
    status: item.status
  }))
